<template>
    <div id="app">
        <main role="main" class="main-cont">
            <div class="row m-0 main-section">
                <div class="col-sm-12 right-section homebody">
                    <div class="row" style="margin-top:30px;">
                        <div class="col-sm-2 ">
                        </div>
                        <div class="col-sm-8 card bg-light">
                            <div class="row" style="margin-top: 20px;margin-bottom: 20px;">
                                <div class="col">
                                    <h4 class="mb-4">Bank Description And Totv Account Number Mapping</h4>
                                </div>
                            </div>
                            <div class="panelDiv">
                                <!-- Button to Open the Modal -->
                                <button id="btnNewMap"
                                        type="button"
                                        class="btn btn-primary float-right"
                                        data-toggle="modal"
                                        data-target="#myModal"
                                        @click="modalview">
                                    Add New Mapping
                                </button>
                                <button id="btnDownloadTemplate"
                                        type="button"
                                        class="btn btn-primary"
                                        @click="downloadTemplate" style="margin-right:2em;">
                                    <font-awesome-icon :icon="['fas', 'download']" class="icon download" style="width:16px;height:16px;" />
                                    Download Template
                                </button>
                                <button id="btnUploadTemplate"
                                        type="button"
                                        class="btn btn-primary"
                                        data-toggle="modal"
                                        data-target="#uploadTemplateModal"
                                        @click="templatemodalview">
                                    <font-awesome-icon :icon="['fas', 'upload']" class="icon upload" style="width:16px;height:16px;" />
                                    Upload Template
                                </button>
                                <div class="container">
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="container">
                                        <!-- Mapping Modal -->
                                        <div class="modal" id="myModal">
                                            <div class="modal-dialog">
                                                <div class="modal-content" style="margin-top:50%;">
                                                    <!-- Modal Header -->
                                                    <div class="modal-header">
                                                        <h4 class="modal-title">Add Mapping</h4>
                                                        <button type="button" class="close" data-dismiss="modal" @click="resetModal">&times;</button>
                                                    </div>
                                                    <!-- Modal body -->
                                                    <div class="modal-body">
                                                        <div class="container" v-if="adddialog">
                                                            <div class="row">
                                                                <div class="col">
                                                                    <label>Bank Name</label>
                                                                    <input type="text"
                                                                           class="form-control"
                                                                           v-model="editedItem.bankName"
                                                                           list="bankdetails"
                                                                           @input="handleclientMapping"
                                                                           v-validate="'required'" name="bankName"
                                                                           v-bind:class="{'is-invalid':errors.has('bankName')}" />
                                                                    <datalist id="bankdetails">
                                                                        <option v-for="bankitem in bankListDetails"
                                                                                v-bind:key="bankitem.itemid">
                                                                            {{bankitem.name}}
                                                                        </option>
                                                                    </datalist>
                                                                    <span v-show="errors.has('bankName')"
                                                                          class="text-danger">Please select the Bank Name</span>
                                                                </div>
                                                                <div class="col">
                                                                    <label>Client Name</label>
                                                                    <input type="text"
                                                                           class="form-control"
                                                                           v-model="editedItem.clientName"
                                                                           list="clientdetails" v-validate="'required'"
                                                                           name="clientName"
                                                                           v-bind:class="{'is-invalid':errors.has('clientName')}" />
                                                                    <datalist id="clientdetails">
                                                                        <option v-for="clientitem in clientListDetails"
                                                                                v-bind:key="clientitem.item">
                                                                            {{clientitem.name}}
                                                                        </option>
                                                                    </datalist>
                                                                    <span v-show="errors.has('clientName')"
                                                                          class="text-danger">Please select the Client Name</span>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col">
                                                                    <label>Bank Description</label>
                                                                    <input type="text"
                                                                           class="form-control"
                                                                           v-model="editedItem.descName"
                                                                           list="descriptionarrayresult"
                                                                           v-on:change="handleUpdatedDescription"
                                                                           v-validate="'required'"
                                                                           name="descName"
                                                                           v-bind:class="{'is-invalid':errors.has('descName')}" />

                                                                    <datalist id="descriptionarrayresult">
                                                                        <option v-for="bankdesc in descriptionarrayresult"
                                                                                v-bind:key="bankdesc.id">
                                                                            {{ bankdesc.name }}
                                                                        </option>
                                                                    </datalist>
                                                                    <span v-show="errors.has('clientName')"
                                                                          class="text-danger">Please Select Bank Description</span>
                                                                </div>
                                                                <div class="col">
                                                                    <label>Account Number</label>
                                                                    <input type="text"
                                                                           class="form-control"
                                                                           v-model="editedItem.accountNo"
                                                                           list="accountnoarrayresult"
                                                                           v-on:change="handleUpdatedAccountNo"
                                                                           v-validate="'required'"
                                                                           name="accountNo"
                                                                           v-bind:class="{'is-invalid':errors.has('accountNo')}" />

                                                                    <datalist id="accountnoarrayresult">
                                                                        <option v-for="totv in accountnoarrayresult"
                                                                                v-bind:key="totv.id">
                                                                            {{ totv.name }}
                                                                        </option>
                                                                    </datalist>
                                                                    <span v-show="errors.has('clientName')"
                                                                          class="text-danger">Please Select Account Number</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="container" v-if="addmessagedialog">
                                                            <div class="alert alert-info">
                                                                <strong>{{addmessage}}</strong>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- Modal footer -->
                                                    <div class="modal-footer">
                                                        <button type="button"
                                                                class="btn btn-info"
                                                                @click="addMapping"
                                                                v-if="adddialog"
                                                                v-bind:disabled="errors.any()">
                                                            Add Mapping
                                                        </button>
                                                        <button type="button" class="btn btn-danger" data-dismiss="modal" @click="resetModal">Close</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Upload Modal -->
                                        <div class="modal" id="uploadTemplateModal">
                                            <div class="modal-dialog">
                                                <div class="modal-content" style="margin-top:50%;">
                                                    <!-- Modal Header -->
                                                    <div class="modal-header">
                                                        <h4 class="modal-title">Add Details</h4>
                                                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                                                    </div>
                                                    <!-- Modal body -->
                                                    <div class="modal-body">
                                                        <div class="container" v-if="adddialog">
                                                            <div class="row">
                                                                <div class="col">
                                                                    <label>Bank Name</label>
                                                                    <input type="text"
                                                                           class="form-control"
                                                                           v-model="editedItem.bankName"
                                                                           list="bankdetails"
                                                                           @input="handleclientMapping"
                                                                           v-validate="'required'" name="bankName"
                                                                           v-bind:class="{'is-invalid':errors.has('bankName')}" />
                                                                    <datalist id="bankdetails">
                                                                        <option v-for="bankitem in bankListDetails"
                                                                                v-bind:key="bankitem.itemid">
                                                                            {{bankitem.name}}
                                                                        </option>
                                                                    </datalist>
                                                                    <span v-show="errors.has('bankName')"
                                                                          class="text-danger">Please select the Bank Name</span>
                                                                </div>
                                                                <div class="col">
                                                                    <label>Client Name</label>
                                                                    <input type="text"
                                                                           class="form-control"
                                                                           v-model="editedItem.clientName"
                                                                           list="clientdetails" v-validate="'required'"
                                                                           name="clientName"
                                                                           v-bind:class="{'is-invalid':errors.has('clientName')}" />
                                                                    <datalist id="clientdetails">
                                                                        <option v-for="clientitem in clientListDetails"
                                                                                v-bind:key="clientitem.item">
                                                                            {{clientitem.name}}
                                                                        </option>
                                                                    </datalist>
                                                                    <span v-show="errors.has('clientName')"
                                                                          class="text-danger">Please select the Client Name</span>
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-9 col-md-7 dp-inline-fx"></div>
                                                            <div class="col-sm-12 col-md-12">
                                                                <label>Upload Template File (.xlsx)</label>
                                                                <div class="row">
                                                                    <div class="file-upload col-sm-12 col-md-12 col-12">
                                                                        <div class="file-select" v-bind:class="{'is-invalid':errors.has('chooseTemplate')}">
                                                                            <div class="file-select-name col-sm-8 col-md-8 col-8" id="noFile">{{UploadTemplate}}</div>
                                                                            <input class="col-sm-12 col-md-12 col-12"
                                                                                   type="file"
                                                                                   title="Choose Bank statement file"
                                                                                   aria-label="Click browse to select Template File"
                                                                                   name="chooseTemplate"
                                                                                   id="uploadTemplateFile"
                                                                                   ref="uploadTemplateFile"
                                                                                   v-validate="`required|size:${fileSize}`"
                                                                                   v-on:change="handleTemplateFile()"
                                                                                   accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
                                                                            <button class="file-select-button col-sm-4 col-md-4 col-4" aria-label="Browse to select template file" title="Browse button" id="fileName">Browse</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <span v-show="errors.has('chooseTemplate')"
                                                                      class="text-danger">Please select a valid Template</span>
                                                            </div>
                                                        </div>
                                                        <div class="container" v-if="addmessagedialog">
                                                            <div class="alert alert-info">
                                                                <strong>{{addmessage}}</strong>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- Modal footer -->
                                                    <div class="modal-footer">
                                                        <button type="button"
                                                                class="btn btn-info"
                                                                @click="uploadTemplateDetails"
                                                                v-if="adddialog"
                                                                v-bind:disabled="errors.any()">
                                                            Upload Template
                                                        </button>
                                                        <button type="button" class="btn btn-danger" data-dismiss="modal" @click="resetModal">Close</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="container">
                                        <div class="row col-sm-12">
                                            <div class="col">
                                                <table id="user-table"
                                                       class="table table-striped display table-bordered nowrap"
                                                       cellspacing="0"
                                                       width="100%">
                                                    <thead>
                                                        <tr>
                                                            <th>BuisnessruleID</th>
                                                            <th>Bank Name</th>
                                                            <th>Client Name</th>
                                                            <th>Bank Description</th>
                                                            <th>Totv Account No</th>
                                                            <th data-orderable="false">Delete</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody></tbody>
                                                </table>
                                            </div>
                                            <div class="container">
                                                <div class="modal" id="deleteModal">
                                                    <div class="modal-dialog">
                                                        <div class="modal-content">
                                                            <div class="modal-header">
                                                                <h5 class="modal-title">Delete Mapping</h5>
                                                                <button type="button" id="btnDeleteId" class="close" data-dismiss="modal" aria-label="Close">
                                                                    <span aria-hidden="true">&times;</span>
                                                                </button>
                                                            </div>
                                                            <div class="modal-body">
                                                                Are you sure?
                                                            </div>
                                                            <div class="modal-footer">
                                                                <button type="button" class="btn" id="deleteMap" v-on:click="deleteMapping">Delete</button>
                                                                <button type="button" data-dismiss="modal" class="btn btn-primary">Cancel</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
    import ACRService from '../../services/ACRService/ACR.service.js';
    import CommonService from '../../services/SharedService/common.service.js'
    import Algorithm from "../../services/Algorithm.js";
    import { EnvironmentConfig } from '../../services/constants.js';
    import $ from 'jquery';
    export default {
        name: "ACRAdminBuisnessRule",
        mixins: [ACRService, CommonService, Algorithm],
        data: () => ({
            fileSize: EnvironmentConfig._FileSize,
            UploadTemplate: "Choose file (Max file size 100 MB)",
            uploadTemplateFile: "",
            dialog: false,
            adddialog: true,
            addmessagedialog: false,
            addmessage: "",
            dataTable: null,
            bankClientListDetails: [],
            bankclientdetails: [],
            bankdetails: [],
            clientdetails: [],
            bankListDetails: [],
            clientListDetails: [],
            selectedDescription: {
                id: "",
                name: ""
            },
            selectedAccountNo: {
                id: "",
                name: ""
            },
            descriptionAccountMap: [],
            descriptionarrayresult: [],
            accountnoarrayresult: [],
            editedIndex: -1,
            editedItem: {
                bankName: "",
                clientName: "",
                bankId: "",
                clientId: "",
                descId: "",
                accountnoId: "",
                descName: "",
                accountNo: ""
            },
            editItem: {
                bankName: "",
                clientName: "",
                bankId: "",
                clientId: "",
                descId: "",
                accountnoId: "",
                descName: "",
                accountNo: ""
            },
        }),
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Item" : "Edit Item";
            }
        },
        watch: {
            dialog(val) {
                val || this.close();
            }
        },
        created() {
            localStorage.setItem("route", this.$route.name);
        },
        methods: {
            modalview() {
                this.adddialog = true;
                this.addmessagedialog = false;
                this.addmessage = "";
                this.editedItem.bankName = "";
                this.editedItem.clientName = "";
                this.editedItem.descName = "";
                this.editedItem.accountNo = "";
            },
            templatemodalview() {
                this.adddialog = true;
                this.addmessagedialog = false;
                this.addmessage = "";
                this.editedItem.bankName = "";
                this.editedItem.clientName = "";
                this.uploadTemplateFile = "";
            },
            navigateUploadDashboard() {
                this.$router.push("/ACRHome");
            },
            deleteMapping() {
                this.RemoveDescriptionAccountMapping()
                    .then(response => {
                        if (response.data == "success") {
                            this.addUser();
                            $('#deleteModal').modal('toggle');
                        }
                    });
            },
            addUser() {
                this.dataTable.clear().draw();
                this.GetBuisnessLogic().then(Response => {
                    if (Response) {
                        this.bankclientdetails = Response.data;
                        this.bankdetails = this.bankclientdetails;
                        this.clientdetails = this.bankclientdetails;
                        this.clientdetails = this.bankclientdetails;
                        this.bankdescription = this.bankclientdetails;
                        this.totvAccountno = this.bankclientdetails;
                        this.bankclientdetails.forEach(bankdetailitem => {
                            this.dataTable.row
                                .add([bankdetailitem.businessRuleID, bankdetailitem.bankName, bankdetailitem.clientName, bankdetailitem.bankDescription, bankdetailitem.toTvsAccountNo, '<button href="#" class="deleteBtn" > Delete </button>'])
                                .draw();
                        });
                        return Response;
                    }

                });
            },
            getKeyByValue(prop, value) {
                let emptyObject = {
                    bankName: "",
                    clientName: "",
                    bankId: -1,
                    clientId: -1,
                    descId: -1,
                    accountnoId: -1,
                    descName: "",
                    accountNo: ""
                };
                let temp = {};
                if (prop === "bankDescription")
                    temp = this.descriptionarrayresult.find(item => item.name === value).id;
                else if (prop == "toTvsAccountNo")
                    temp = this.accountnoarrayresult.find(item => item.name === value).id;
                else if (prop == "bankname")
                    temp = this.bankListDetails.find(item => item.name === value).id;
                else if (prop == "clientname")
                    temp = this.clientListDetails.find(item => item.name === value).id;

                if (typeof temp !== "undefined") {
                    return temp;
                } else {
                    return emptyObject;
                }
            },

            handleclientMapping() {
                this.editedItem.clientName = "";
                this.clientListDetails = [];
                for (var i = 0; i < this.bankandclientmap.length; i++) {
                    if (this.bankandclientmap[i].bankname == this.editedItem.bankName) {
                        this.clientListDetails.push({
                            id: this.bankandclientmap[i].clientId,
                            name: this.bankandclientmap[i].clientname
                        })
                    }
                }
            },

            handleUpdatedDescription() {
                var temp = this.getKeyByValue("bankDescription", this.editedItem.descName);
                this.editItem.descName = this.editedItem.descName;
                this.editItem.descId = temp;
            },
            handleUpdatedAccountNo() {
                var temp = this.getKeyByValue("toTvsAccountNo", this.editedItem.accountNo);
                this.editItem.accountNo = this.editedItem.accountNo;
                this.editItem.accountnoId = temp;
            },
            findMappingId() {
                for (var i = 0; i < this.bankandclientmap.length; i++) {
                    if (this.bankandclientmap[i].bankname == this.editedItem.bankName && this.bankandclientmap[i].clientname == this.editedItem.clientName) {
                        return this.bankandclientmap[i].id;
                    }
                }
            },
            uploadTemplateDetails() {
                if (this.editedItem.bankName !== '' && this.editedItem.clientName !== '' && this.uploadTemplateFile !== undefined) {
                    const formData = new FormData();
                    formData.append("Bankname", this.editedItem.bankName);
                    formData.append("Clientname", this.editedItem.clientName);
                    formData.append("UserId", localStorage.getItem('userId'));
                    formData.append("File", this.uploadTemplateFile);
                    this.UploadTemplateDetail(formData).then(Response => {
                        if (Response && !Response.isAxiosError) {
                            if (Response.data === "Success") {
                                this.addUser();
                                this.adddialog = false;
                                this.addmessagedialog = true;
                                this.addmessage = "Details added successfully";
                            };
                        }
                    });
                } else {
                    this.addUser();
                    this.adddialog = false;
                    this.addmessagedialog = true;
                    this.addmessage = "Please enter valid data";
                }
            },
            handleTemplateFile() {
                this.uploadTemplateFile = this.$refs.uploadTemplateFile.files[0];
                this.UploadTemplate = this.uploadTemplateFile.name;
            },
            downloadTemplate() {
                this.DownloadRule();
            },
            addMapping() {
                console.log(this.$validator.errors);
                if (this.editedItem.bankName != undefined && this.editedItem.clientName != undefined && this.editedItem.descName != undefined && this.editedItem.accountNo != undefined) {
                    this.bankclientmapId = this.findMappingId();
                    this.loading = true;
                    if (this.editedIndex > -1) {
                        Object.assign(
                            this.bankclientdetails[this.editedIndex],
                            this.editedItem
                        );
                    } else {
                        // For Adding Only Bank
                        if (this.editedItem.bankId === -1 && this.editedItem.clientId > -1) {
                            this.editItem.bankId = 0;
                            this.editItem.clientId = this.editedItem.clientId;
                            this.editItem.bankname = this.editedItem.bankname;
                            this.editItem.clientname = this.editedItem.clientname;
                        }
                        // For Adding Only Client
                        if (this.editedItem.bankId > -1 && this.editedItem.clientId === -1) {
                            this.editItem.bankId = this.editedItem.bankId;
                            this.editItem.clientId = 0;
                            this.editItem.bankname = this.editedItem.bankname;
                            this.editItem.clientname = this.editedItem.clientname;
                        }
                        // For Adding Both Bank and Client
                        if (this.editedItem.bankId === -1 && this.editedItem.clientId === -1) {
                            this.editItem.bankId = 0;
                            this.editItem.clientId = 0;
                            this.editItem.bankname = this.editedItem.bankname;
                            this.editItem.clientname = this.editedItem.clientname;
                        }
                        var authorizeToken = this.authenticateUser(localStorage.getItem('userId'), EnvironmentConfig._APIURL);
                        console.log(this.editedItem.bankName + " " + this.editedItem.clientName + " " + this.editedItem.descName + " " + this.editedItem.accountNo);
                        this.AddBuisnessLogic(this.editedItem.bankName, this.editedItem.clientName, this.editedItem.descName, this.editedItem.accountNo, localStorage.getItem('userId'), authorizeToken)
                            .then(Response => {
                                if (Response) {
                                    var resp = Response.data;
                                    if (resp == "Selected BusinessRule alreday exists") {
                                        this.adddialog = false;
                                        this.addmessagedialog = true;
                                        this.addmessage = "Selected BusinessRule alreday exists";

                                    }
                                    else if (resp == "") {
                                        this.adddialog = false;
                                        this.addmessagedialog = true;
                                        this.addmessage = "Error occured during Buisness rule mapping ";
                                    }
                                    else {
                                        this.addUser();
                                        this.adddialog = false;
                                        this.addmessagedialog = true;
                                        this.addmessage = "BusinessRule Saved Successfully";
                                    }
                                } else {
                                    this.adddialog = false;
                                    this.addmessagedialog = true;
                                    this.addmessage = "Error occured during Buisness rule mapping ";
                                }
                            })
                            .catch(function () {
                                this.adddialog = false;
                                this.addmessagedialog = true;
                                this.addmessage = "Error occured during Buisness rule mapping";
                            });
                    }
                }
            },
            resetModal() {
                this.addmessage = "";
                this.editedItem.descName = "";
                this.editedItem.accountNo = "";

                this.editedItem.bankName = '';
                this.editedItem.clientName = '';
                this.adddialog = true;
                this.addmessagedialog = false;
                this.$validator.errors.clear();
                this.uploadTemplateFile = "";
                this.UploadTemplate = "Choose file (Max file size 100 MB)";
            }
        },
        mounted() {
            this.dataTable = $("#user-table").DataTable({
                "order": [],
                "pageLength": 50,
                "columnDefs": [
                    {
                        "targets": [0],
                        "visible": false,
                        "searchable": false
                    }
                ]
            });
            var table = this.dataTable;
            this.GetBuisnessLogic().then(Response => {
                if (Response) {
                    this.bankclientdetails = Response.data;
                    this.bankdetails = this.bankclientdetails;
                    this.clientdetails = this.bankclientdetails;
                    this.bankdescription = this.bankclientdetails;
                    this.totvAccountno = this.bankclientdetails;
                    this.bankclientdetails.forEach(bankdetailitem => {
                        table.row
                            .add([bankdetailitem.businessRuleID, bankdetailitem.bankName, bankdetailitem.clientName, bankdetailitem.bankDescription, bankdetailitem.toTvsAccountNo, '<button href="#" class="deleteBtn" > Delete </button>'])
                            .draw();
                    });

                    $('#user-table tbody').on('click', '.deleteBtn', function () {
                        $('#deleteModal').modal({
                            backdrop: 'static',
                            keyboard: false,
                        });
                        var buisnessruleID = table.row($(this).parents('tr')).data()[0];
                        localStorage.setItem("buisnessruleID", buisnessruleID);

                    });

                    table
                        .row($(this).parents('tr'))
                        .remove().draw(false);


                    return Response;
                }
            });
            var authorizeToken = this.authenticateUser(localStorage.getItem('userName'), EnvironmentConfig._APIURL);
            this.BankClientMapping(authorizeToken).then(response => {
                if (response) {
                    this.bankandclientmap = response.data;
                    const map = new Map();
                    for (const item of this.bankandclientmap) {
                        if (!map.has(item.bankId)) {
                            map.set(item.bankId, true);    // set any value to Map
                            this.bankListDetails.push({
                                id: item.bankId,
                                name: item.bankname

                            });
                        }
                    }
                }
            });
            var authorizationToken = this.authenticateUser(null, EnvironmentConfig._APIURL);
            this.BankDesAndAccNo(authorizationToken).then(response => {
                if (response) {
                    for (const item in response.data) {
                        var entity = response.data[item].entityName;
                        var itemname = response.data[item].name;

                        var itemid = response.data[item].id;
                        if (entity == 'acr.BankDescriptions') {
                            this.descriptionarrayresult.push({
                                id: itemid,
                                name: itemname
                            })
                            //this.descriptionarrayresult.push(name);
                        }
                        if (entity == 'acr.ToTvsAccountNo') {
                            this.accountnoarrayresult.push({
                                id: itemid,
                                name: itemname
                            })
                            //this.accountnoarrayresult.push(name);
                        }
                    }

                }
            });
        }
    };
</script>
<style>
    .group {
        display: flex;
        flex: 1;
        justify-content: space-around;
    }

    #reconBtn {
        margin-right: 5px;
        width: 170px;
        float: right;
    }

    #btnNewMap {
        margin-right: -10px;
        width: 170px;
    }
</style>
